<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="活动专区标题：" prop="activityTitle">
        <el-input style="width: 424px;" v-model="ruleForm.activityTitle" placeholder="请输入活动专区标题"></el-input>
      </el-form-item>
      <el-form-item label="活动专区标题图片：" prop="activityImg">
        <upload-img :fileList="activityImgList" :imgWhich="1" warmTxt="建议尺寸：288*88px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="活动专区背景图片：" prop="activityBackImg">
        <upload-img :fileList="activityBackImgList" :imgWhich="2" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="新人福利背景图片：" prop="userWelfareBackImg">
        <upload-img :fileList="userWelfareBackImgList" :imgWhich="3" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="拼团背景图片：" prop="pinTuanBackImg">
        <upload-img :fileList="pinTuanBackImgList" :imgWhich="4" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="优惠券背景图片：" prop="couponBackImg">
        <upload-img :fileList="couponBackImgList" :imgWhich="5" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="套餐背景图片：" prop="mealComboBackImg">
        <upload-img :fileList="mealComboBackImgList" :imgWhich="6" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="砍价背景图片：" prop="bargainBackImg">
        <upload-img :fileList="bargainBackImgList" :imgWhich="7" warmTxt="建议尺寸：750*532px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
export default {
  name: 'BgImg',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        activityTitle:'',
        activityImg:'',
        activityBackImg:'',
        userWelfareBackImg:'',
        pinTuanBackImg:'',
        couponBackImg:'',
        mealComboBackImg:'',
        bargainBackImg:''
      },
      activityImgList: [],
      activityBackImgList:[],
      userWelfareBackImgList:[],
      pinTuanBackImgList:[],
      couponBackImgList:[],
      mealComboBackImgList:[],
      bargainBackImgList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    var that = this;
    fetchShopConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.activityTitle = data.activityTitle
        that.ruleForm = data
        if(data.activityImg != ''){
          that.activityImgList.push({url: data.activityImg})
        }
        if(data.activityBackImg != ''){
          that.activityBackImgList.push({url: data.activityBackImg})
        }
        if(data.userWelfareBackImg != ''){
          that.userWelfareBackImgList.push({url: data.userWelfareBackImg})
        }
        if(data.pinTuanBackImg != ''){
          that.pinTuanBackImgList.push({url: data.pinTuanBackImg})
        }
        if(data.couponBackImg != ''){
          that.couponBackImgList.push({url: data.couponBackImg})
        }
        if(data.mealComboBackImg != ''){
          that.mealComboBackImgList.push({url: data.mealComboBackImg})
        }
        if(data.bargainBackImg != ''){
          that.bargainBackImgList.push({url: data.bargainBackImg})
        }
      }
    })
  },
  methods: {
    imgUrlBtn(backData){
      if(backData.imgWhich == 1){
        // 活动专区标题图片
        this.ruleForm.activityImg = backData.imgUrl;
      }else if(backData.imgWhich == 2){
        // 活动专区背景图片
        this.ruleForm.activityBackImg = backData.imgUrl;
      }else if(backData.imgWhich == 3){
        // 新人福利背景图片
        this.ruleForm.userWelfareBackImg = backData.imgUrl;
      }else if(backData.imgWhich == 4){
        // 拼团背景图片
        this.ruleForm.pinTuanBackImg = backData.imgUrl;
      }else if(backData.imgWhich == 5){
        // 优惠券背景图片
        this.ruleForm.couponBackImg = backData.imgUrl;
      }else if(backData.imgWhich == 6){
        // 套餐背景图片
        this.ruleForm.ruleForm.mealComboBackImg = backData.imgUrl;
      }else if(backData.imgWhich == 7){
        // 砍价背景图片
        this.ruleForm.bargainBackImg = backData.imgUrl;
      }
    },
    // 保存操作
    saveBtn () {
      let that = this
      let activityTitle = that.ruleForm.activityTitle
      let activityImg = that.ruleForm.activityImg
      let activityBackImg = that.ruleForm.activityBackImg
      let userWelfareBackImg = that.ruleForm.userWelfareBackImg
      let pinTuanBackImg = that.ruleForm.pinTuanBackImg
      let couponBackImg = that.ruleForm.couponBackImg
      let mealComboBackImg = that.ruleForm.mealComboBackImg
      let bargainBackImg = that.ruleForm.bargainBackImg
      that.fullscreenLoading = true
      saveOrUpdateShopConfig({activityTitle:activityTitle,activityImg:activityImg,activityBackImg:activityBackImg,userWelfareBackImg:userWelfareBackImg,pinTuanBackImg:pinTuanBackImg,couponBackImg:couponBackImg,mealComboBackImg:mealComboBackImg,bargainBackImg:bargainBackImg}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/BgImg.vue